import { IEntity } from 'interfaces/entity';
import React, { Component } from 'react';
import RxOp from 'rxjs-operators';
import selectedVentureService from 'services/profile';

import AreaBar from './AreaBar';
import SubTabsArea from './SubTabArea';
import TabPanel from './TabPanel';

interface IState {
  value: number;
  subTabValue: number;
  selectedVenture: number;
}
interface IProps {
  children?: React.ReactNode;
  entityGraph?: IEntity;
  onChange: () => void;
}

export default class TabBar extends Component<IProps, IState> {
  state = {
    value: 0,
    subTabValue: 0,
    selectedVenture: 0,
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    selectedVentureService
      .getSelectedVenture()
      .pipe(RxOp.logError(), RxOp.bindComponent(this))
      .subscribe((selection) => {
        if (selection && selection.id) {
          this.setState({ selectedVenture: selection.id });
        }
      });
  };

  onChangeValue = (prop: 'value' | 'subTabValue') => (
    event: any,
    value: any
  ) => {
    this.setState(
      {
        ...this.state,
        [prop]: value,
      },
      this.props.onChange
    );
  };

  render() {
    const { entityGraph } = this.props;
    const { value, subTabValue, selectedVenture } = this.state;
    const filterVenture = (tab: IEntity) =>
      tab.ventureId === selectedVenture || tab.ventureId === null;
    const entityGraphChildren = entityGraph.children.filter((tab) =>
      filterVenture(tab)
    );
    return (
      <>
        <AreaBar
          areas={entityGraphChildren}
          changeValue={this.onChangeValue('value')}
          value={value}
        />
        {entityGraphChildren.map((tab, index) => (
          <div key={`tabpanel-tab-${index + tab.name}_tab`}>
            {tab.children.filter((tab) => filterVenture(tab)).length > 0 && (
              <TabPanel
                index={`tabpanel-tab-${index}-${tab.name}`}
                value={`tabpanel-tab-${value}-${tab.name}`}
              >
                <SubTabsArea
                  subTabValue={subTabValue}
                  onChangeValue={this.onChangeValue('subTabValue')}
                  areas={tab.children.filter((tab) => filterVenture(tab))}
                />
              </TabPanel>
            )}
          </div>
        ))}
      </>
    );
  }
}
